import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'
import * as appTypes from '@/store/actions/app'
import languages from './languages'
const merge = require('webpack-merge')

Vue.use(MLInstaller)

const clientLanguage = process.env.CLIENT_LANGUAGE

export default new MLCreate({
  initial: appTypes.APP_DEFAULT_LANGUAGE,
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('es_ES').create(merge(languages['es_ES'], clientLanguage['es_ES'])),
    new MLanguage('en_GB').create(merge(languages['en_GB'], clientLanguage['en_GB'])),
    new MLanguage('ca_ES').create(merge(languages['ca_ES'], clientLanguage['ca_ES']))
  ]
})



// WEBPACK FOOTER //
// ./src/language/index.js